export enum Brand {
  MITULA = 'MITULA',
  NESTORIA = 'NESTORIA',
  NUROA = 'NUROA',
  PROPERATI = 'PROPERATI',
  LAMUDI = 'LAMUDI',
  HIPFLAT = 'HIPFLAT',
  TROVIT = 'TROVIT',
  MYPROPERTY = 'MYPROPERTY',
}
